(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hzo-collection"] && !Shopify.designMode) return;
  try {
    
  /* De keuze stuurt het formulier zelf op, en dan is de knop Go overbodig.
     Andersom: zonder JavaScript blijft de knop staan en werkt sorteren gewoon.
     Gedelegeerd op document, want Horizon tekent secties opnieuw in de editor en
     luisteraars op het element zelf overleven dat niet. */
  if (!document.documentElement.dataset.hzoSorteer) {
    document.documentElement.dataset.hzoSorteer = 'true';
    document.addEventListener('change', (e) => {
      const keuze = e.target.closest && e.target.closest('.hzo-sorteer__keuze');
      if (!keuze || !keuze.form) return;
      /* Zelf navigeren in plaats van het formulier opsturen, zodat wat er al in de
         adresbalk staat blijft staan — met name `preview_theme_id`. */
      const adres = new URL(keuze.form.getAttribute('action') || window.location.pathname, window.location.origin);
      new URLSearchParams(window.location.search).forEach((waarde, naam) => {
        if (naam !== 'sort_by' && naam !== 'page') adres.searchParams.set(naam, waarde);
      });
      adres.searchParams.set('sort_by', keuze.value);
      window.location.href = adres.toString();
    });
  }
  document.querySelectorAll('.hzo-sorteer__go').forEach((k) => {
    k.style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hzo-search"] && !Shopify.designMode) return;
  try {
    
  /* Zelfde afhandeling als op de collectiepagina: de keuze stuurt zichzelf op en
     neemt mee wat er al in de adresbalk staat (de zoekterm, en tijdens het
     nakijken `preview_theme_id`). Zonder JavaScript blijft de knop Go staan en
     werkt het formulier gewoon. */
  if (!document.documentElement.dataset.hzoZoekSorteer) {
    document.documentElement.dataset.hzoZoekSorteer = 'true';
    document.addEventListener('change', (e) => {
      const keuze = e.target.closest && e.target.closest('.hzo-coll--zoek .hzo-sorteer__keuze');
      if (!keuze || !keuze.form) return;
      const adres = new URL(keuze.form.getAttribute('action') || window.location.pathname, window.location.origin);
      new URLSearchParams(window.location.search).forEach((waarde, naam) => {
        if (naam !== 'sort_by' && naam !== 'page') adres.searchParams.set(naam, waarde);
      });
      adres.searchParams.set('sort_by', keuze.value);
      window.location.href = adres.toString();
    });
  }
  document.querySelectorAll('.hzo-coll--zoek .hzo-sorteer__go').forEach((k) => {
    k.style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
